import { CloudProviderData } from '../wizard-plugin-models/cloud-provider-data';
import { SoftwareData } from '../wizard-plugin-models/software-data';

/**
 * Represents a Virtual Machine image configuration for a course.
 * This class contains information about cloud provider details and software installed.
 * @class CourseVMImage
 */
export class CourseVMImage {
  /**
   * Cloud provider configuration details for the VM image.
   * Includes information about provider, region, size, and storage.
   * @type {CloudProviderData}
   * @default new CloudProviderData()
   */
  public cloudProviderData: CloudProviderData = new CloudProviderData();

  /**
   * Software configuration details for the VM image.
   * Includes OS, SDKs, databases, editors, and other software.
   * @type {SoftwareData}
   * @default new SoftwareData()
   */
  public softwareData: SoftwareData = new SoftwareData();
}
